<script setup>
import {defineEmits, defineProps, computed, toRefs} from "vue"

const props = defineProps({
  modelValue: {}
});
const {modelValue} = toRefs(props);

const emit = defineEmits(['update:modelValue'])

const label = computed({
  get: () => props.modelValue?.data?.label,
  set: (value) => emit('update:modelValue', { ...props.modelValue, data: { ...props.modelValue.data, label: value } })
})

const value = computed({
  get: () => props.modelValue?.data?.value,
  set: (value) => emit('update:modelValue', { ...props.modelValue, data: { ...props.modelValue.data, value } })
})

</script>

<template>
	<div>
    <p>Текст заголовка</p>
    <a-input v-model:value="label" />

    <p>Размер заголовка</p>
    <a-select
        v-model:value="value"
        style="width: 120px"
        :dropdown-style="{ zIndex: 1001111111 }"
    >
      <a-select-option value="1">1</a-select-option>
      <a-select-option value="2">2</a-select-option>
      <a-select-option value="3">3</a-select-option>
      <a-select-option value="4">4</a-select-option>
      <a-select-option value="5">5</a-select-option>
      <a-select-option value="6">6</a-select-option>
      <a-select-option value="7">7</a-select-option>
    </a-select>
	</div>
</template>

<style lang="scss" scoped>
</style>
